// @ts-ignore
/* eslint-disable */
import request from '../../../requestInstance';
import { CommonResult } from '../../CommonType';

export async function getProfileByAccountId(
  params: { accountId: number },
  options?: { [key: string]: any },
) {
  return request<CommonResult<API.ProfileInfo>>(`/api/profile/${params.accountId}`, {
    method: 'GET',
    ...(options || {}),
  });
}

export async function createProfile(
  data: API.CreateProfileRequest,
  options?: { [key: string]: any },
) {
  return request<CommonResult<void>>('/api/profile/create', {
    method: 'POST',
    data,
    ...(options || {}),
  });
}

export async function updateProfile(
  data: API.UpdateProfileRequest,
  options?: { [key: string]: any },
) {
  const formData = new FormData();
  Object.entries(data).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      formData.append(key, value as any);
    }
  });

  return request<CommonResult<void>>('/api/profile/update', {
    method: 'POST',
    data: formData,
    requestType: 'form',
    ...(options || {}),
  });
}

export async function updateProfileBankAccount(
  data: API.UpdateProfileBankAccountRequest,
  options?: { [key: string]: any },
) {
  return request<CommonResult<void>>('/api/human-resources/employee-info/bank-account/update', {
    method: 'POST',
    data,
    ...(options || {}),
  });
}

export async function updateProfilePassword(
  data: { currentPassword: string; newPassword: string },
  options?: { [key: string]: any },
) {
  return request<CommonResult<void>>('/api/profile/password/update', {
    method: 'POST',
    data,
    ...(options || {}),
  });
}

export async function uploadProfileImage(
  data: { accountId: number; file: any },
  options?: { [key: string]: any },
) {
  const formData = new FormData();
  formData.append('accountId', data.accountId.toString());
  formData.append('file', data.file);

  return request<CommonResult<string>>('/api/profile/image/upload', {
    method: 'POST',
    data: formData,
    requestType: 'form',
    skipErrorHandler: false,
    ...(options || {}),
  });
}
